import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	oneColumn: {
		defaultMessage: 'One column',
		id: 'dashboard-edit.header-editable.change-layout-button.layout-picker.one-column',
		description: 'Description of one column',
	},
	twoColumns: {
		defaultMessage: 'Two columns',
		id: 'dashboard-edit.header-editable.change-layout-button.layout-picker.two-columns',
		description: 'Description of two columns',
	},
	threeColumns: {
		defaultMessage: 'Three columns',
		id: 'dashboard-edit.header-editable.change-layout-button.layout-picker.three-columns',
		description: 'Description of three columns',
	},
	leftSidebar: {
		defaultMessage: 'Left sidebar',
		id: 'dashboard-edit.header-editable.change-layout-button.layout-picker.left-sidebar',
		description: 'Description of left sidebar',
	},
	rightSidebar: {
		defaultMessage: 'Right sidebar',
		id: 'dashboard-edit.header-editable.change-layout-button.layout-picker.right-sidebar',
		description: 'Description of right sidebar',
	},
});
